import React, { FC } from 'react'

import { PresenterVipDescriptionContainer } from 'components/page/ForeignProfile/Gifts/PresentVip/PresenterVipDescriptionContainer'
import { PresentVipStoreFrontButton } from 'components/page/ForeignProfile/Gifts/PresentVip/PresentVipStoreFrontButton'
import { PresentVipTitle } from 'components/page/ForeignProfile/Gifts/PresentVip/PresentVipTitle'
import { GQLForeignRootQuery } from 'components/page/ForeignProfile/gql/__generated__/ForeignRoot'
import { MessageVipCurrentView } from 'components/page/ProfileGiftsModal/Message/MessageVipCurrentView'
import { MessageVipForeignView } from 'components/page/ProfileGiftsModal/Message/MessageVipForeignView'
import { MessageVipView } from 'components/page/ProfileGiftsModal/Message/MessageVipView'
import { UserCard } from 'components/presentational/card/UserCard'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

export const PresentVipDescription: FC<{
  presenter: NonNullable<
    NonNullable<
      NonNullable<GQLForeignRootQuery['user']>['vip']['presentVip']
    >['presenter']
  >
  days: number
}> = ({ presenter, days }) => {
  const { currentUserId } = useShallowEqualSelector(
    ({ userReducer: { userId } }) => ({
      currentUserId: userId,
    })
  )

  const isCurrentUser = presenter.id === currentUserId

  return (
    <PresenterVipDescriptionContainer>
      <UserCard
        title={
          <PresentVipTitle
            profileId={presenter.id}
            name={presenter.name}
            age={presenter.age}
            isVerifiedPhotos={presenter.verification.verifiedPhotos}
            isOnline={presenter.online?.status}
            location={presenter.location.name}
          />
        }
        text={
          <>
            <MessageVipView gender={presenter.gender} vipDays={days} />
            <br />
            {isCurrentUser ? (
              <MessageVipCurrentView />
            ) : (
              <MessageVipForeignView />
            )}
          </>
        }
      >
        <PresentVipStoreFrontButton />
      </UserCard>
    </PresenterVipDescriptionContainer>
  )
}
